export default "__VITE_ASSET__CAlFKJSF__"